import {
    defineIconService,
    SharedIconService
} from '@volkswagen-onehub/icon-service';
import {SpaGlobalConfig} from '../../../generated/core';
import {getIconUrl} from '../../utils/getIconUrl';
import {ServiceRegistration} from './ServiceRegistration';

export function createIconService(
    globalConfig: SpaGlobalConfig
): ServiceRegistration<SharedIconService> {
    return {
        definition: defineIconService({
            getIconUrl(iconName, variant) {
                return getIconUrl(iconName, variant, globalConfig);
            }
        })
    };
}
